import productSchema from "./product";
import productSchemaGICL from "./productGICL";
import productSchemaGICO from "./productGICO";

export default {
  productSchema,
  productSchemaGICL,
  productSchemaGICO
}
